module.exports = __webpack_public_path__ + "img/monarch-ui-icon_ORTHOLOG_DISEASE.76865641.png";